import {
  ExchangeFeedback,
  PredefinedInsight,
  SessionItem,
} from "../graphql/types/graphql";
import {
  References,
  RuleBasedCitation,
} from "fe-web-components/references/types";
import { Guideline } from "fe-web-components/guidelines/types";
import { MutableRefObject } from "react";

export enum MessageType {
  question = 1,
  answer = 2,
  suggestedQuestions = 3,
}
export enum SessionActionStatus {
  invalid,
  error,
  success,
}
export enum LoginRequestType {
  none,
  login,
  saveChat,
}
export enum SessionStatus {
  normal,
  updating,
  deleting,
  duplicating,
  loading,
}
export enum QuestionTypes {
  Chat = "Chat",
  Summary = "Summary",
}
export enum SessionType {
  PATIENT = "patient",
  GENERAL = "general",
}
export const DEFAULT_SESSION_TYPE = SessionType.GENERAL;

export type Stream = {
  text: string;
  metaData: Record<string, any>;
};
export type ClinicData = {
  id?: string;
  name?: string;
};
export type QuestionType = QuestionTypes | PredefinedInsight | string;

export interface ChatMessage {
  index: number;
  type: MessageType;
  text: string;
  references?: References;
  guidelines?: Guideline[];
  questions?: string[]; //suggested questions
  feedback?: ExchangeFeedback;
  ref?: MutableRefObject<any>; //save the ref of the message for scrolling
  isValid?: boolean;
  loading?: boolean;
}
export type SessionInsights = Partial<Record<string, ChatMessage>>;
export type SessionWithStatus = SessionItem & { status: SessionStatus };
export type AppSettingsItem = { name: string; settings: any };
export type AppLanguages = "hebrew" | "english";
export type AppSettings = {
  name?: string;
  language?: AppLanguages;
  hideGuidelinesContactButton?: boolean;
  hideGuidelinesIgnoreButton?: boolean;
  defaultSessionType?: SessionType;
  supportedSessionTypes?: SessionType[];
  hideUserOccupationSurvey?: boolean;
  guidelineTriggerStrategy?: string;
};
export type SessionExchange = {
  answer?: string;
  citations?: RuleBasedCitation[]; //* deprecated - use references */
  guidelines?: Guideline[];
  altGuidelines?: Guideline[];
  index?: number;
  question?: string;
  references?: References;
  sessionDate?: string;
  sessionId?: string;
  sessionType?: string;
  sessionUser?: string;
  feedback?: ExchangeFeedback;
  valid?: boolean;
};
export type AddSessionReply = {
  sessionId: string;
  status: SessionActionStatus;
};
export type CustomPrompts = Partial<Record<string, string>>;
export type GuidelineFilterValue = {
  value: string;
  doc_count: number;
};
export type GuidelineFilter = {
  displayName: string;
  filterKey: string;
  values: GuidelineFilterValue[];
};
